module.exports = __webpack_public_path__ + "static/media/the-nightly.bbfb43e9.svg";